import AddParticipantModal from './AddParticipantModal';

export default AddParticipantModal;
